import { Image, Row, Col, Button } from "react-bootstrap";
import useWindowDimensions from "../../utils/useWindowDimensions";
import { scroller } from 'react-scroll';
import { Link } from 'react-router-dom'

import proposingBanner from "../../assets/images/voting_banner_2.png"

import styles from "./ProposeHeaderContent.module.css";

const scrollToSection = () => {
    scroller.scrollTo('homePageVotingSection', { //check Voting.js to find this class
        duration: 300,
        delay: 0,
        smooth: "easeInOutQuart",
    });
}

function ProposeHeaderContent() {
    const { height, width } = useWindowDimensions();
    return (
        <Row className={styles.ContentContainer}>
            <Col className="d-flex align-items-center">
                <div>
                    <div className={styles.headerTitle}>LET EVERYONE KNOW</div>
                    <div className={styles.headerSubtext}>Voton is the perfect platform to showcase your potential ideas, engage with the community that helps you to raise funds as well as gather feedback. Create your momentum and let everyone know how you can contribute to future of humanity.</div>
                    <Button className={styles.headerButtons} onClick={() => scrollToSection()}>
                        <div className={styles.headerButtonText}>Make a Proposal</div>
                    </Button>
                    {width < 992 ?
                        <Col>
                            <Link to="buy-voton">
                                <Button className={styles.headerButtons} onClick={() => scrollToSection()}>
                                    <div className={styles.headerButtonText}>Buy Token</div>
                                </Button>
                            </Link>
                        </Col> : <></>}
                    {width < 992 ?
                        <Col>
                            <Image src={proposingBanner} className={styles.votingBanner}></Image>
                        </Col>
                        : <></>
                    }
                </div>
            </Col>
            {width < 992 ? <></> :
                <Col style={{ textAlign: 'end', position: 'relative' }}>
                    <Image src={proposingBanner} className={styles.votingBanner}></Image>
                </Col>
            }

        </Row>
    );
}

export default ProposeHeaderContent;
